export default __webpack_public_path__ + "static/media/BrainBreak cards63.0573e120.png";